function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.131,
  cy: 17.333,
  r: 15,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2410_66488)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.65 13.9h-1.63c-1.06 0-1.8-.73-1.8-1.79v-1.63h-6.19c-.45 0-.66.22-.66.67v3.3c0 .43-.4.71-.77.56-.23-.1-.37-.27-.37-.52 0-1.18-.02-2.36 0-3.53.02-.87.77-1.6 1.64-1.62h6.8a.8.8 0 01.62.25 604.2 604.2 0 003.26 3.26.8.8 0 01.24.6V23.5c0 1.11-.72 1.83-1.83 1.83h-4.41c-.45 0-.73-.4-.57-.78.1-.23.3-.36.59-.36h4.39c.1 0 .21 0 .31-.04.22-.08.35-.24.38-.48v-.16-9.6zm-2.28-2.56v.94c.02.24.23.46.47.47.32.02.64 0 .95 0l-1.42-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.18 25a4.4 4.4 0 11.03-8.81 4.4 4.4 0 01-.03 8.8zm3.32-4.4a3.3 3.3 0 10-6.61 0 3.3 3.3 0 006.6 0zM16.79 13.9h-1.64c-.38 0-.64-.23-.64-.57 0-.33.26-.57.64-.57h3.3c.37 0 .62.24.63.57 0 .33-.26.58-.63.58h-1.66zM20.21 16.76h-1.64c-.37 0-.64-.23-.63-.57 0-.34.26-.57.64-.57h3.28c.38 0 .64.23.65.57 0 .34-.26.57-.65.57H20.2zM20.78 19.62H19.7c-.37 0-.62-.24-.62-.58 0-.33.26-.56.62-.56h2.18c.36 0 .62.23.62.56 0 .34-.25.58-.63.58h-1.09zM20.8 21.33h1.09c.36 0 .62.25.61.58 0 .32-.25.56-.6.57h-2.21c-.35 0-.6-.25-.61-.57 0-.33.25-.57.61-.58h1.11z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M14.4 20.53H12M13.2 21.73v-2.4"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2410_66488"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z",
  transform: "translate(8.798 9.333)"
})));

function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.84ef4315.svg";
export { ForwardRef as ReactComponent };